import { render, staticRenderFns } from "./SozlesmeAlacakKalemiForm.vue?vue&type=template&id=677ef58e"
import script from "./SozlesmeAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./SozlesmeAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports